import { z } from 'zod';
import { hexColorSchema, idSchema, isoDateTimeSchema } from './common.js';
// Role armazenada como VARCHAR(32) — string livre com defaults conhecidos.
// Roles documentados: gerente | colaborador | social_media | gestor | admin.
export const roleSchema = z.string().min(1).max(32);
export const userSchema = z.object({
    id: idSchema,
    name: z.string().min(1).max(120),
    username: z.string().min(1).max(60),
    email: z.string().email().max(190),
    password_hash: z.string().max(255),
    role: roleSchema.default('colaborador'),
    color_hex: hexColorSchema.nullable(),
    avatar_url: z.string().max(500).nullable(),
    is_active: z.boolean(),
    must_change_password: z.boolean(),
    created_at: isoDateTimeSchema,
    updated_at: isoDateTimeSchema,
});
// Versão pública (sem password_hash) — entregue por GET /users e /auth/me.
export const userPublicSchema = userSchema.omit({ password_hash: true });
// Roles canônicos pra checagem de permissões.
export const CANONICAL_ROLES = ['admin', 'gerente', 'social_media'];
export const canonicalRoleSchema = z.enum(CANONICAL_ROLES);
// Input pra criar usuário (gerente/admin).
export const userCreateInputSchema = z.object({
    name: z.string().min(1).max(120),
    username: z.string().min(1).max(60).regex(/^[a-z0-9_]+$/, 'Somente letras minúsculas, números e _'),
    email: z.string().email().max(190),
    password: z.string().min(6).max(128),
    role: canonicalRoleSchema.default('social_media'),
    color_hex: hexColorSchema.optional().nullable(),
});
// Input pra editar usuário (gerente edita nome/email/cor; admin tudo + role + is_active).
export const userUpdateInputSchema = z.object({
    name: z.string().min(1).max(120).optional(),
    email: z.string().email().max(190).optional(),
    role: canonicalRoleSchema.optional(),
    color_hex: hexColorSchema.nullable().optional(),
    is_active: z.boolean().optional(),
});
// Input pra alterar a própria senha.
export const changePasswordInputSchema = z.object({
    current: z.string().min(1),
    next: z.string().min(6).max(128),
});
// Input pra admin/gerente definir senha provisória de outro usuário (6 dígitos numéricos).
export const userResetPasswordInputSchema = z.object({
    password: z.string().regex(/^\d{6}$/, 'Use exatamente 6 dígitos numéricos'),
});
// Input pra editar próprio perfil (nome/email/cor — NÃO role nem is_active).
export const meUpdateInputSchema = z.object({
    name: z.string().min(1).max(120).optional(),
    email: z.string().email().max(190).optional(),
    color_hex: hexColorSchema.nullable().optional(),
});
export const avatarFitSchema = z.object({
    img_w: z.number().positive(),
    img_h: z.number().positive(),
    scale: z.number().positive().max(10),
    rotate: z.number().min(-180).max(180).default(0),
    x: z.number(),
    y: z.number(),
});
//# sourceMappingURL=user.js.map